import styled, { css } from "styled-components";

import { pxToRem } from "@anwb/poncho/design-tokens/style-utilities";
import { Theme } from "@anwb/poncho/design-tokens/theme";

import { customVariables } from "@topgun/shared-front-end/src/theme/custom-variables";
import { AuthorImageProps } from "@topgun/shared-front-end/src/types/frontend";
import { getBackgroundPositionCssForImageWithFocalPoint } from "@topgun/shared-front-end/src/utils/focalPoint";
import { scaleBynderImage } from "@topgun/shared-front-end/src/utils/image";

type DefaultThemeProps = {
  theme: Theme;
};

type ChapterImageProps = {
  image?: AuthorImageProps;
};

const fullscreenChapterImageStyles = ({ image }: DefaultThemeProps & ChapterImageProps) => css`
  position: relative;
  min-height: 80vh;
  margin-top: -90px;
  padding-top: 100px;
  background-image: linear-gradient(
      90deg,
      rgba(0, 15, 34, 1) 0%,
      rgba(0, 0, 0, 0.25) 50%,
      rgba(0, 15, 34, 0.75) 100%
    ),
    url(${image && scaleBynderImage(image.url)});

  background-size: cover;
  ${getBackgroundPositionCssForImageWithFocalPoint(image)}

  background-repeat: no-repeat;
  background-blend-mode: darken;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 30vh;
    background: linear-gradient(0deg, ${customVariables.colors.primaryBackground}, transparent);
  }
`;

export const FullscreenChapterImage = styled.div<{ image?: AuthorImageProps }>`
  ${fullscreenChapterImageStyles}
`;

const fullscreenChapterBlockStyling = ({ theme }: DefaultThemeProps) => css`
  position: relative;
  width: 66.66%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: stretch;
  padding: 1.5rem;
  background-color: rgb(0 0 0 / 25%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 0.75rem;
  cursor: pointer;
  @media (max-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
    width: 100%;
  }
`;

export const FullscreenChapterBlock = styled.div`
  ${fullscreenChapterBlockStyling}
`;

const fullscreenProgressBarWrapperStyles = () => css`
  padding: 0.5rem 0;
`;

export const FullscreenChapterProgressBarWrapper = styled.div`
  ${fullscreenProgressBarWrapperStyles}
`;
const fullscreenChapterHeaderStyles = () => css`
  display: flex;
  gap: 15px;
`;

export const FullscreenChapterHeader = styled.div`
  ${fullscreenChapterHeaderStyles}
`;
